module.exports = __webpack_public_path__ + "static/media/fonts-6.59d4155f.svg";